/**
 * The Launcher Client is now known as the AppsClient. The Launcher Client
 * (found at `FSBL.Clients.LauncherClient`) is an alias to
 * the [AppsClient](/docs/reference/typedocs/modules/AppsClient/)
 * provided for backward compatibility. See [AppsClient](/docs/reference/typedocs/modules/AppsClient/)
 * documentation for details.
 *
 * @module LauncherClient
 */
import AppsClient, { WindowDescriptor, WindowIdentifier } from "./appsClient";
import { FinsembleWindow } from "../common/FinsembleWindow";
import { Logger } from "./logger";

export type SpawnResponse = {
	windowDescriptor: WindowDescriptor;
	windowIdentifier: WindowIdentifier;
	launchGroupWindows?: string[];
	/**
	 * @internal
	 */
	finWindow: FinsembleWindow;
};

/**
 * @ignore
 */
export const LauncherClient = {
	/**
	 * For backward compatibility
	 * @private
	 * @deprecated
	 */
	initialize: () => {
		Logger.system.deprecated("It is no longer necessary to call LauncherClient.initialized()");
	},
	/**
	 * For backward compatibility
	 * @private
	 * @deprecated
	 */
	onReady: (cb?: any) => {
		Logger.system.deprecated("It is no longer necessary to call LauncherClient.onReady()");
		cb?.();
	},
	addToGroups: AppsClient.addToGroups,
	getGroupsForWindow: AppsClient.getGroupsForWindow,
	removeWindowsFromGroup: AppsClient.removeWindowsFromGroup,
	addWindowsToGroup: AppsClient.addWindowsToGroup,
	createWindowGroup: AppsClient.createWindowGroup,
	minimizeWindows: AppsClient.minimizeWindows,
	hyperFocus: AppsClient.hyperFocus,
	bringWindowsToFront: AppsClient.bringWindowsToFront,
	getComponentsThatCanReceiveDataTypes: AppsClient.getComponentsThatCanReceiveDataTypes,
	removeUserDefinedComponent: AppsClient.removeUserDefinedComponent,
	addUserDefinedComponent: AppsClient.addUserDefinedComponent,
	getPendingWindows: AppsClient.getPendingWindows,
	getActiveAndPendingWindowNames: AppsClient.getActiveAndPendingWindowNames,
	getActiveDescriptors: AppsClient.getActiveDescriptors,
	getMyWindowIdentifier: AppsClient.getMyWindowIdentifier,
	getMonitor: AppsClient.getMonitor,
	spawn: AppsClient.spawn,
	clone: AppsClient.clone,
	toggleWindowOnClick: AppsClient.toggleWindowOnClick,
	showWindow: AppsClient.showWindow,
	unRegisterComponent: AppsClient.unRegisterComponent,
	registerComponent: AppsClient.registerComponent,
	getMonitorInfo: AppsClient.getMonitorInfo,
	getMonitorInfoAll: AppsClient.getMonitorInfoAll,
	getComponentDefaultConfig: AppsClient.getComponentDefaultConfig,
	getComponentList: AppsClient.getComponentList,
	addApps: AppsClient.addApps,
	removeApps: AppsClient.removeApps,
	getApps: AppsClient.getApps,
	spawnTabCollection: AppsClient.spawnTabCollection,
};

export default LauncherClient;
